import * as React from "react";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Layout from "../../layout/Main/Layout";
import { Typography } from "@mui/material";
import { get, del } from "../../config/axios";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const UserInfo = () => {
    const [rows, setRows] = useState([]);

    const columns = [
        { field: "id", headerName: "S. No", width: 100 },
        { field: "name", headerName: "Full Name", width: 200 },
        { field: "age", headerName: "Age", width: 90, type: "number" },
        { field: "gender", headerName: "Gender", width: 120 },
        { field: "email", headerName: "Email Address", width: 250 },
        { field: "phone", headerName: "Phone Number", width: 250 },
        {
            field: "actions",
            headerName: "Action",
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete(params.row._id)}
                    color="error"
                >
                    <DeleteIcon />
                </IconButton>
            ),
        },
    ];

    const fetchUserInfo = async () => {
        try {
            const data = await get("/api/dashboard/website/userinfo");
            setRows(data.map((user, index) => ({ ...user, id: index + 1 })));
        } catch (error) {
            console.error("Error fetching user information:", error);
        }
    };

    const handleDelete = async (userId) => {
        try {
            await del(`/api/dashboard/website/userinfo/${userId}`);
            fetchUserInfo(); // Refresh the list after deletion
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    };

    useEffect(() => {
        fetchUserInfo();
    }, []);

    const paginationModel = { page: 0, pageSize: 5 };

    return (
        <Layout>
            <div style={{ padding: "1rem" }}>
                <Typography variant="h5" paddingY={2}>User Information</Typography>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        sx={{
                            border: 0,
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold',
                            },
                        }}
                    />
                </Paper>
            </div>
        </Layout>
    );
};

export default UserInfo;